import { render } from "./LeftSideBar.vue?vue&type=template&id=82f979be&scoped=true&ts=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=ts"
export * from "./LeftSideBar.vue?vue&type=script&lang=ts"

import "./LeftSideBar.vue?vue&type=style&index=0&id=82f979be&lang=css"
import "./LeftSideBar.vue?vue&type=style&index=1&id=82f979be&lang=less&scoped=true"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f979be"]])

export default __exports__